import { render, staticRenderFns } from "./ApplicationTemplate.vue?vue&type=template&id=c811cc48&scoped=true"
import script from "./ApplicationTemplate.vue?vue&type=script&lang=js"
export * from "./ApplicationTemplate.vue?vue&type=script&lang=js"
import style0 from "./ApplicationTemplate.vue?vue&type=style&index=0&id=c811cc48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c811cc48",
  null
  
)

export default component.exports